

import { SET_KEY, GET_KEY } from './actions';
import session from "./session";
import keys from "./keys";
import constants from '../utils/constants';

const initialState = {
    isLoggedIn: session.get(keys.isLoggedIn) == 'true' ? true : false,
    language: session.get(keys.language) || "en",
    direction: session.get(keys.direction) || "ltr",
    isLoading: false,
    showLogin: false,
    showSignup: false,
    allowSignups: true,
    showSimilarAds: true,
    showAnnouncementBar: false,
    announcement: ``,
    maintenanceMode: false,
    maintenanceMessage: ``,
    showResetPassword: false,
    user: session.getParsed(keys.user) || null,
    cookie: session.get(keys.cookie) || ``,
    token: session.get(keys.token) || ``,
    currentLocation: session.get(keys.currentLocation) || ``,
    startConversation: session.get(keys.startConversation) || null,
    usersCityId: session.getParsed(keys.user) && session.getParsed(keys.user).cityId || ``,
    searchCityId: `nationwide`,
    searchCategoryId: ``,
    searchKeyword: ``,
    searchCategory: session.get(keys.searchCategory) || ``,
    searchCategories: session.get(keys.searchCategories) || ``,
    searchTypes: session.get(keys.searchTypes) || ``,
    searchBrands: session.get(keys.searchBrands) || ``,
    searchPriceMin: session.get(keys.searchPriceMin) || constants.minPrice,
    searchPriceMax: session.get(keys.searchPriceMax) || constants.maxPrice,
    selectedRegion: session.getParsed(keys.selectedRegion) || null,
    cart: session.getParsed(keys.cart) || null,
    deliveryAddress: session.getParsed(keys.deliveryAddress) || null,
    counter: session.get(keys.counter) || 1,
    cookiesAccepted: session.get(keys.cookiesAccepted) || false,
    openCategoriesCollapsible: session.get(keys.openCategoriesCollapsible) || false,
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_KEY:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };

        case GET_KEY:
            return {
                ...state
            };

        default:
			return state;
    }
}

export default reducer;